import { mapState, mapActions } from 'vuex';
import store from '@/store/store';

export const LanguageHelpers = {
  methods: {
    ...mapActions(['getTranslatedAppLabels']),

    async setUrlLanguage(urlLang) {
      try {
        if (urlLang === this.defaultLanguage) return;

        store.state.defaultLanguage = urlLang;

        const payload = {
          code: urlLang
        };
        await this.getTranslatedAppLabels(payload);
      } catch (e) {
        console.log(e);
      }
    }
  },

  computed: {
    ...mapState({
      defaultLanguage: state => state.defaultLanguage
    })
  }
};
